import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { loadPublicResourcesForHub } from "@/lib/query-registry";
import { ResourceHub, collectionPageJsonLd } from "@/components/site/ResourceHub";
import { SITE_URL } from "@/lib/i18n";
import coverConv from "@/assets/cover-pillar-conversion.jpg";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/resources/conversion";
const ALT = "/es/recursos/conversion";
const TITLE = "Shopify CRO Resources: PDP, Checkout, UX · Shugert";
const DESC =
  "Index of our Shopify CRO playbooks, PDP clarity, mobile UX, checkout friction, size returns and A/B testing. Start with the Shopify Conversion Rate Optimization Playbook.";

export const Route = createFileRoute("/resources/conversion")({
  loader: async ({ context }) => {
    await setEdgeHtmlCache();
    return loadPublicResourcesForHub(context.queryClient);
  },
  head: ({ loaderData }) => {
    const resources = (loaderData as any)?.resources ?? [];
    const urls = resources
      .filter((r: any) =>
        (r.tags_en ?? []).join(" ").toLowerCase().match(/cro|conversion|checkout|pdp|ux|size guide/),
      )
      .map((r: any) => `${SITE_URL}/resources/${r.slug}`);
    return buildHead({
      locale: "en",
      title: TITLE,
      description: DESC,
      path: PATH,
      altPath: ALT,
      ogImage: coverConv,
      jsonLd: [
        breadcrumbJsonLd([
          { name: "Home", path: "/" },
          { name: "Resources", path: "/resources" },
          { name: "Conversion", path: PATH },
        ]),
        collectionPageJsonLd("Shopify CRO Resources", `${SITE_URL}${PATH}`, DESC, urls),
      ],
    });
  },
  component: () => (
    <SiteShell>
      <ResourceHub
        locale="en"
        cluster="conversion"
        copy={{
          eyebrow: "CRO resources",
          title: "Shopify CRO resources: PDP, checkout, UX and testing.",
          intro:
            "An index of our conversion work on Shopify. Start here → the Shopify Conversion Rate Optimization Playbook is the pillar; the articles below cover PDP clarity, mobile UX, checkout friction, size returns and A/B testing.",
          serviceLabel: "See CRO + SEO",
          serviceHref: "/shopify-cro",
          articlesTitle: "Conversion guides",
          articlesEmpty: "More conversion guides coming soon. Want a CRO audit? Request a scope.",
          read: "Read",
          min: "min",
          by: "By",
          updated: "Updated",
          backLabel: "Resources",
          backHref: "/resources",
        }}
      />
    </SiteShell>
  ),
});